export class ShippingcostPrice {
	id: number;
	shippingcost_id: number;
	country_id: string;
	order_total_from: number;
	order_total_to: number;
	min_products: number;
	max_products: number;
	zipcode_from: number;
	zipcode_to: number;
    price_incl: number;
    price_excl: number;
    tax_rate_class_id: number;
	created_at: string;
	updated_at: string;
	
	remove: boolean;
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/shippingcost_price.ts